export const FIC_RATE_LIMIT_MESSAGE =
  "Fatture in Cloud ha temporaneamente limitato le richieste API. Affidya conserva l'ultimo stato SDI disponibile e tenterà automaticamente un nuovo aggiornamento. Non è necessario ripetere manualmente l'operazione.";

export function retryIsActive(stato) {
  const value = stato?.sync_retry_at || stato?.prossimo_tentativo_at;
  return !!value && new Date(value).getTime() > Date.now();
}

export function retryLabel(stato, formatter) {
  const value = stato?.sync_retry_at || stato?.prossimo_tentativo_at;
  if (!value) return null;
  return formatter ? formatter(value) : new Date(value).toLocaleString("it-IT");
}
